/* MRD — toglie la firma «Powered by Track123» dalla pagina di tracciamento.

   PERCHE' SERVE UN FILE APPOSTA, invece di due righe di foglio di stile.
   La firma non si nasconde con il CSS: l'app le scrive lo stile DIRETTAMENTE
   SULL'ELEMENTO, e per giunta con !important —

     style="... display: block !important; visibility: visible !important; ..."

   Uno stile scritto sull'elemento con !important vince su qualunque regola di
   qualunque foglio: e' cosi' che funziona la cascata. Non e' un caso, hanno
   messo anche visibility. L'unica strada e' togliere l'elemento dopo che
   l'hanno creato. Misurato su Mielora il 19/09/2026 e qui il 06/10/2026.

   PERCHE' NON BASTA FARLO UNA VOLTA SOLA.
   Quella pagina e' un'applicazione che si ridisegna da sola: cambi linguetta,
   cerchi un ordine, e la firma torna insieme al resto. Percio' si resta in
   ascolto e la si toglie ogni volta che ricompare.

   Il file si carica SOLO su /apps/track123 (vedi layout/theme.liquid): sulle
   altre pagine non viene nemmeno chiesto. */

(function () {
  'use strict';

  var ID = 'track123-powered-by';

  function togli() {
    var e = document.getElementById(ID);
    if (!e) return false;
    /* Si toglie dal documento invece di nasconderlo: nascosto, i lettori di
       schermo continuerebbero a leggerlo e resterebbe lo spazio vuoto sotto
       al bottone. */
    e.remove();
    return true;
  }

  togli();

  var radice = document.getElementById('track123-app') || document.body;
  if (!radice || typeof MutationObserver !== 'function') return;

  var osservatore = new MutationObserver(function () { togli(); });
  osservatore.observe(radice, { childList: true, subtree: true });

  /* Rete per i primi dieci secondi: se l'applicazione parte piu' tardi del
     previsto, il contenitore da osservare potrebbe non esistere ancora. */
  var tentativi = 0;
  var timer = setInterval(function () {
    tentativi++;
    if (togli() || tentativi > 40) clearInterval(timer);
  }, 250);
})();
